import { withCn } from "@udecode/cn";

import { Toolbar } from "./toolbar";

export const FixedToolbar = withCn(
  Toolbar,
  "supports-backdrop-blur:bg-transparent sticky left-0 z-20 w-full justify-between overflow-x-auto rounded-t-lg border-b border-b-border bg-transparent backdrop-blur",
);
